import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import "./logincss.css";
import {
  Message,
  Button,
  Header,
  Image,
  Modal,
  Form,
  Icon
} from "semantic-ui-react";
import { Container, Row } from "shards-react";

export class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      redirectToApp: false,
      error: false
    };
  }

  render() {
    const { email, password, redirectToApp } = this.state;

    if (redirectToApp) {
      return <Redirect to="/" />;
    }

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4" />
        <div>
          <h1>Welcome to My Expedia</h1>
          {this.state.error === true && <MessageExampleNegative />}
          <form onSubmit={this.handleSubmit}>
            <p>
              Please you need to regitrer to access to MyExpedia and enjoy the
              webvacation2.0
            </p>

            <label htmlFor="email">Email</label>
            <input
              name="email"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={this.handleChange}
              required
            />
            <label htmlFor="password">Password</label>
            <input
              name="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={this.handleChange}
              required
              minlength="8"
            />
            <button type="submit">Login</button>
          </form>
          <ModalModalExample />
        </div>
      </Container>
    );
  }

  onLogin = async data => {
    var userdata = JSON.stringify(data);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/login`,
      {
        method: "POST",
        body: userdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );
    if (response.status === 200) {
      console.log("Your login is accepted on the server side");
      console.log(response);
      const data = await response.json();
      console.log("data:", data);

      sessionStorage.setItem("token", data[0].token);
      sessionStorage.setItem("userimage", data[0].PICURL);
      sessionStorage.setItem("username", data[0].NAME);
      sessionStorage.setItem("usersurname", data[0].SURNAME);
      sessionStorage.setItem("isadmin", data[0].ISADMIN);
      sessionStorage.setItem("userID", data[0].ID);
      sessionStorage.setItem("useremail", data[0].EMAIL);
      sessionStorage.setItem("description", data[0].DESCRIPTION);

      window.location.reload();
      this.setState({ redirectToApp: true });
    } else {
      console.error("login and password don't match on the database");
      this.setState({ error: true });
    }
    if (response.status === 501) {
      console.error("login and password don't match on the database");
      this.setState({ error: true });
    }
  };

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleSubmit = event => {
    console.log("Submitting");
    console.log(this.state);
    event.preventDefault();
    this.onLogin(this.state);
  };
}
// Modal
class ModalModalExample extends Component {
  state = { open: false, registred: false };

  areYouRegistred = () => {
    console.log("Check if new user is allowed by server ....");
    this.setState({
      registred: true
    });
  };

  render() {
    return (
      <div className="mybuttoncontainer">
        <Modal trigger={<Button>Registrer here</Button>} closeIcon>
          {this.state.registred === true && <MessageExampleDismissibleBlock />}
          <Modal.Header>Registration</Modal.Header>
          <Modal.Content image>
            <Image
              wrapped
              size="medium"
              src="https://react.semantic-ui.com/images/avatar/large/rachel.png"
            />

            <Modal.Description>
              <Header>Default Profile Image</Header>
              <FormExampleCaptureValues
                AfterRegistration={this.areYouRegistred}
              />
              <p>Is it okay to use this photo?, we will use it by default</p>
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}
export default ModalModalExample;

class FormExampleCaptureValues extends Component {
  state = {
    surname: "",
    name: "",
    email: "",
    submittedName: "",
    submittedEmail: "",
    thepassword: "",
    PICURL: "",
    DESCRIPTION: ""
  };

  onRegistrer = async data => {
    const { AfterRegistration } = this.props;
    var userdata = JSON.stringify(data);
    console.log(userdata);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/newusers`,
      {
        method: "POST",
        body: userdata,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );
    if (response.status === 200) {
      console.log("The new user is in the database");
      AfterRegistration();
    } else {
      console.error(
        "The server didn't accept your registration, Maybe the server is offline"
      );
    }
  };

  handleChange = (
    e,
    { thepassword, surname, name, PICURL, DESCRIPTION, value }
  ) =>
    this.setState({
      [name]: value,
      [surname]: value,
      [thepassword]: value,
      [PICURL]: value,
      [DESCRIPTION]: value
    });

  handleSubmit = () => {
    const {
      DESCRIPTION,
      PICURL,
      surname,
      thepassword,
      name,
      email
    } = this.state;

    this.setState({
      PICURL: PICURL,
      thepassword: thepassword,
      submittedName: name,
      submittedEmail: email
    });
    console.log(this.state);
    let userdata = {
      password: thepassword,
      name: name,
      surname: surname,
      isadmin: false,
      email: email,
      PICURL: PICURL,
      DESCRIPTION: DESCRIPTION
    };
    this.onRegistrer(userdata);
  };

  render() {
    const {
      thepassword,
      surname,
      name,
      email,
      submittedName,
      submittedEmail,
      DESCRIPTION,
      PICURL
    } = this.state;

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Input
              placeholder="Name"
              name="name"
              value={name}
              onChange={this.handleChange}
              required
            />
            <Form.Input
              placeholder="Surname"
              name="surname"
              value={surname}
              onChange={this.handleChange}
              required
            />
          </Form.Group>
          <Form.Input
            placeholder="Your pic profile URL - Enter an https:// URL: "
            name="PICURL"
            value={PICURL}
            onChange={this.handleChange}
            type="url"
          />
          <Form.Input
            placeholder="Email"
            name="email"
            value={email}
            onChange={this.handleChange}
            required
            type="email"
          />{" "}
          <Form.Input
            placeholder="Description"
            name="DESCRIPTION"
            value={DESCRIPTION}
            onChange={this.handleChange}
          />{" "}
          <Form.Input
            placeholder="Password"
            name="thepassword"
            type="password"
            value={thepassword}
            onChange={this.handleChange}
            required
            minLength="8"
          />{" "}
          <Form.Button content="Submit" />
        </Form>
      </div>
    );
  }
}
class MessageExampleDismissibleBlock extends Component {
  state = { visible: true };

  handleDismiss = () => {
    this.setState({ visible: false });

    setTimeout(() => {
      this.setState({ visible: true });
    }, 2000);
  };

  render() {
    if (this.state.visible) {
      return (
        <Message
          onDismiss={this.handleDismiss}
          header="Your are correctly regitred on My Expedia!"
          content="There is no mail confirmation needed just connect with your mail and password :)."
        />
      );
    }

    return (
      <p>
        <br />
        <i>Please quit this modal and login with you new id and password </i>
        <br />
        <br />
      </p>
    );
  }
}

class MessageExampleNegative extends Component {
  state = { visible: true };

  handleDismiss = () => {
    this.setState({ visible: false });

    setTimeout(() => {
      this.setState({ visible: true });
    }, 2000);
  };

  render() {
    if (this.state.visible) {
      return (
        <Message
          negative
          onDismiss={this.handleDismiss}
          header="Login and Password don't match !"
          content="Sorry maybe you need to registrer on MyExpedia first."
        />
      );
    }

    return (
      <p>
        <br />
        <i>Please try again or registrer yourself</i>
        <br />
        <br />
      </p>
    );
  }
}
